import config from '@config'

import {
    GET_APP_STATE,
    GET_APP_STATE_REQUEST,
    POST_APP_STATE,
    POST_APP_STATE_REQUEST,
    SET_NEW_APP_STATE,
    UPDATE_APP_STATE,
} from './constants'

export const getAppState = () => ({
    type: GET_APP_STATE,
})

export const getAppStateRequest = (sid) => ({
    type: GET_APP_STATE_REQUEST,
    payload: {
        ...config.api.getAppState,
        headers: {
            sid,
        },
    },
})

export const postAppState = () => ({
    type: POST_APP_STATE,
})

export const postAppStateRequest = (appState, sid) => ({
    type: POST_APP_STATE_REQUEST,
    payload: {
        ...config.api.postAppState,
        headers: {
            sid,
        },
        body: {
            appState,
        },
    },
})

export const setNewAppState = (appState) => ({
    type: SET_NEW_APP_STATE,
    data: {
        appState,
    },
})

export const updateAppState = (moduleName, key, value) => ({
    type: UPDATE_APP_STATE,
    data: {
        moduleName,
        key,
        value,
    },
})
